import React, { createContext, useCallback, useContext, useState } from 'react';
import InviteTalentToShiftModal from './InviteTalentToShiftModal';

/**
 * Iter-186 — global provider for the Individual Talent Invite modal so any
 * admin surface (Discover Talent, Talent Profile Modal, Applicant Drawer,
 * Admin User Detail, etc.) can launch the same modal via a hook without
 * prop-drilling state. Mirrors TalentProfileModalProvider.
 *
 * Iter-193 — the open() helper now accepts an optional `shift` argument
 * so the modal can preselect the *live* shift instead of defaulting to
 * the first row from /open-next-14-days (which used to pull fake Miami
 * "Administrative Assistant" seeds).
 */
const InviteTalentToShiftContext = createContext({ open: () => {} });

export const InviteTalentToShiftProvider = ({ children }) => {
  const [talentUserId, setTalentUserId] = useState(null);
  const [talentName, setTalentName] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [preselectedShift, setPreselectedShift] = useState(null);

  const open = useCallback((id, name, shift) => {
    if (!id) return;
    setTalentUserId(String(id));
    setTalentName(name || null);
    setPreselectedShift(shift && shift.id ? shift : null);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setPreselectedShift(null);
  }, []);

  return (
    <InviteTalentToShiftContext.Provider value={{ open, close }}>
      {children}
      <InviteTalentToShiftModal
        open={isOpen}
        onOpenChange={(o) => { if (!o) close(); }}
        talentUserId={talentUserId}
        talentName={talentName}
        preselectedShift={preselectedShift}
      />
    </InviteTalentToShiftContext.Provider>
  );
};

export const useInviteTalentToShift = () => useContext(InviteTalentToShiftContext);

export default InviteTalentToShiftProvider;
